import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const STYLE = {
  GET_LISTA_STYLE: createActionTypes("GET_LISTA_STYLE"),
  GET_STYLE: createActionTypes("GET_STYLE"),
  SAVE_STYLE: createActionTypes("SAVE_STYLE"),

  GET_STYLE_HISTORY: createActionTypes("GET_STYLE_HISTORY"),
  GET_STYLE_HISTORY_LIST: createActionTypes("GET_STYLE_HISTORY_LIST"),

  CHANGE_PAGE_SIZE_STYLE: "CHANGE_PAGE_SIZE_STYLE",
  LOAD_EMPTY_STYLE: "LOAD_EMPTY_STYLE",
  CLEAN_MESSAGE_STYLE: "CLEAN_MESSAGE_STYLE",
  DISABLE_LOADING_STYLE: "DISABLE_LOADING_STYLE"
}